/* HUB-03 (Jan, 2026-10-10): two Data Hub answers that need sql/HUB-03-FAST-PASS-STEPS-AND-SIGNUPS.sql.
   1. The Fast Pass page panel (snippets/ff-data-hub-fastpass-steps.liquid), from datahub_fastpass_steps: "how many
      people actually went into the CRM ... and the drop off in the CRM like maybe people left before they got the fast
      pass".
   2. The New phone numbers tile under At a glance, from datahub_waitlist_signups: "the pdp waitlist now counts as a
      lead so i want the datahub to show that". The Quest's numbers stay as datahub_overview reads them; the waitlist
      adds the numbers it brought that the Quest did not already have, so nobody is counted twice.
   Loaded only by sections/ff-data-hub.liquid, which calls ffHubFunnels.load(key) with the other panels and
   ffHubPhones(overview, window) after it draws At a glance. Uses the hub's own access word (localStorage ffhub_key).
   Before HUB-03 runs, the panel says so and the tile keeps the Quest's numbers.
   Release B (2026-10-13): once QO2-11 adds v2 and a player has used the new Fast Pass page, the panel follows the new
   page's order from that day (renderV2). The panel says which view it shows in #fp-report[data-fp-view].
   QO2-13 (2026-10-16): the new page's ladder adds five side rows from datahub_quest_extra (SIDE3), each "Not counted yet"
   until the server has counted it, and none at all while that report is missing. */
(function(){
  "use strict";
  var SB_URL="https://obadckrukccwkjgpbsxa.supabase.co";
  var SB_KEY="sb_publishable_4DntR53dZydUazuyuPI3YQ_zg69PLYZ";
  function el(id){return document.getElementById(id)}
  function key(){try{return localStorage.getItem("ffhub_key")||""}catch(e){return ""}}
  function rpc(name,body){
    return fetch(SB_URL+"/rest/v1/rpc/"+name,{method:"POST",cache:"no-store",
      headers:{"Content-Type":"application/json","apikey":SB_KEY,"Authorization":"Bearer "+SB_KEY},body:JSON.stringify(body||{})})
      .then(function(r){if(!r.ok){var e=new Error("rpc "+r.status);e.status=r.status;throw e}return r.json()});
  }
  function esc(t){return String(t==null?"":t).replace(/[&<>"']/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]})}
  function n(x){return (Number(x)||0).toLocaleString()}
  function pct(a,b){return b>0?Math.round(100*(Number(a)||0)/b):0}
  function chip(k,v,d){return '<div class="fh-chip"><div class="ck">'+esc(k)+'</div><div class="cv">'+v+'</div><div class="cd">'+(d||"")+'</div></div>'}

  /* ---------------- 1 · the Fast Pass page, step by step ---------------- */
  /* the page's own order (assets/commission-portal-earned.js): the number only for players who came without one */
  var STEPS=[
    ["given","Got their link","finished the Quest with an email"],
    ["opened","Opened the page",""],
    ["phone","In the text line","had a number, or added one first"],
    ["size","Picked a size",""],
    ["spin","Spun the d20 wheel","a border from the wheel"],
    ["library","Visited the library",""],
    ["check","Checked the blueprint",""],
    ["gift","Claimed a class border",""],
    ["notes","Read Jan's three notes",""],
    ["sent","Sent it to Jan","earned the Fast Pass"]
  ];
  /* where a player stopped, named by the step they did not do */
  var LEFT_AT={opened:"Never opened the page",phone:"The phone number step",size:"The size step",spin:"The d20 wheel",library:"The library",
    check:"The blueprint check",gift:"The class border",notes:"Jan's notes",sent:"Why now, and sending it"};
  /* Release B (Jan's pick 1B, 2026-10-13): the new Fast Pass page asks in a new order, and datahub_fastpass_steps adds v2
     for it (sql/QO2-11, add-only, null until the first player uses the new page). v2 counts the links given since that
     day, test runs left out. A later step counts every step before it, except the text line (a real number only). Jan's
     shop, Jan's surprise and the Priority Pass are side steps, read straight from what each player did, and the three gifts
     after Send count as a share of the players who sent it. While v2 is missing or null the panel reads as before. */
  var STEPS2=[
    ["given","Got their link","finished the Quest with an email"],
    ["opened","Opened the page",""],
    ["phone","In the text line","a real number, had or added on the page"],
    ["size","Picked a size",""],
    ["check","Checked the blueprint",""],
    ["sent","Sent it to Jan","earned the Fast Pass"]
  ];
  /* the side rows after each step, and the gifts while they wait (a share of the senders) */
  var SIDE2={size:[["shop","Bought a border at Jan's shop","a side step, paid with Quest gold"]],
    check:[["spin","Jan's surprise","rolled the d20 after the check"],["buy","Tapped Get the Priority Pass before sending","the line under the steps, Have Jan paint before October 2026"]]};
  var WAIT2=[["gift","Picked a class border"],["library","Visited the library"],["notes","Read Jan's three notes"]];
  var LEFT_AT2={opened:"Never opened the page",phone:"The phone number step",size:"The size step",check:"The blueprint check",sent:"Sending it to Jan"};
  /* QO2-13 (Jan's yes, 2026-10-16, the CRM review's gap 2): five more side rows on the new page's ladder, from
     datahub_quest_extra's stamps (add-only). They are the moments the page now tells the server (commission-portal-
     earned.js seenFlow), among the same links as v2 (given since its since, test runs left out). The RPC missing, the
     rows stay away and the ladder reads as before; a count missing or null says "Not counted yet".
       stamps_since (top level: the first of the five ever told, null until the theme sends them); stamps { given, intro,
       greet, shop_skip, phone_view, bp_intro } (null before the new page's first real player, QO2-11's new_since) */
  var SIDE3={opened:[["intro","Passed Jan's welcome","her two lines, tapped through"],["greet","Passed her shop greeting",""],
      ["shop_skip","Tapped Not now in the shop",""],["phone_view","Saw the phone step","only players with no number yet"]],
    size:[["bp_intro","Passed Jan's words at the blueprint","her two lines before the check"]]};
  var NOT_YET="Not counted yet";
  function isNum(x){return typeof x==="number"&&isFinite(x)}
  /* the how-to's paragraph about the five rows shows only while they are drawn */
  function howX(on){var p=document.querySelector("#fp-report .fp-how-x");if(p)p.hidden=!on}
  var FP={d:30,seq:0,k:""};
  function rangeWords(d){return d>=99999?"so far":"in the last "+d+" days"}
  function paintOff(why){
    el("fp-report").setAttribute("aria-busy","false");el("fp-report").setAttribute("data-fp-view","off");howX(false);
    el("fp-off").textContent=why==="key"?"The Fast Pass page needs the hub's access word."
      :"The Fast Pass page switches on once sql/HUB-03-FAST-PASS-STEPS-AND-SIGNUPS.sql has been run in Supabase.";
    el("fp-chips").innerHTML='<div class="fh-empty">Nothing to show yet.</div>';
    el("fp-says").textContent="";el("fp-leaks").hidden=true;el("fp-split").textContent="";el("fp-note").textContent="";
    el("fp-steps").innerHTML='<div class="fh-empty">Nothing to show yet.</div>';
  }
  function render(s,x){
    var v2=s.v2;
    if(v2&&typeof v2==="object"&&v2.since){renderV2(s,v2,x);return}
    el("fp-report").setAttribute("data-fp-view","v1");howX(false);
    var given=Number(s.given)||0,opened=Number(s.opened)||0,sent=Number(s.sent)||0;
    el("fp-off").textContent="";
    el("fp-chips").innerHTML=
      chip("Links given",n(given),"players who finished the Quest with an email")+
      chip("Opened the page",n(opened),pct(opened,given)+"% of the links")+
      chip("Sent to Jan",n(sent),pct(sent,opened)+"% of those who opened it")+
      chip("Bought",n(s.bought),n(s.pass_open)+" "+((Number(s.pass_open)||0)===1?"pass":"passes")+" opened so far");
    /* where they leave: the drop between each step and the next, the biggest first (Quest 1's own list) */
    var leaks=[];
    for(var i=0;i+1<STEPS.length;i++){
      var here=Number(s[STEPS[i][0]])||0,next=Number(s[STEPS[i+1][0]])||0,gone=Math.max(0,here-next);
      if(gone>0)leaks.push({k:STEPS[i+1][0],gone:gone,of:here,rate:pct(gone,here)});
    }
    leaks.sort(function(a,b){return b.gone-a.gone||b.rate-a.rate});
    var top=leaks.slice(0,3),box=el("fp-leaks");
    if(top.length){
      box.innerHTML='<ol class="fh-leak-list" aria-label="The three steps that lose the most players">'+top.map(function(L,k){
        return '<li class="fh-leak'+(k?'':' top')+'"><span class="r" aria-hidden="true">'+(k+1)+'</span><span class="nm">'+esc(LEFT_AT[L.k]||L.k)+'</span>'+
          '<span class="ct"><b>'+n(L.gone)+'</b> left here</span><span class="rt"><span>'+L.rate+'% of the '+n(L.of)+' who got there</span>'+
          '<span class="bar" aria-hidden="true"><i style="width:'+Math.min(100,Math.max(3,L.rate))+'%"></i></span></span></li>';
      }).join("")+'</ol>';
      box.hidden=false;
    }else{box.hidden=true;box.innerHTML=""}
    el("fp-says").innerHTML=given
      ?"Of the <b>"+n(given)+"</b> players given a Fast Pass link "+rangeWords(FP.d)+", <b>"+n(opened)+"</b> opened it and <b>"+n(sent)+"</b> sent it to Jan."+
        (!top.length?"":top[0].k==="opened"?" The biggest drop comes first. <b>"+n(top[0].gone)+"</b> never opened their link."
          :" Most stop at <b>"+esc((LEFT_AT[top[0].k]||"").replace(/^The /,"the ").replace(/^Jan's/,"Jan's").replace(/^Why/,"why"))+"</b>, "+n(top[0].gone)+" of the "+n(top[0].of)+" who got there.")
      :"No player was given a Fast Pass link "+rangeWords(FP.d)+".";
    var base=Math.max(given,1),rows=STEPS.map(function(x){
      var v=Number(s[x[0]])||0;
      return '<div class="fp-step"><span class="l">'+esc(x[1])+'</span><span class="t" aria-hidden="true"><i style="width:'+(100*v/base)+'%"></i></span>'+
        '<span class="v">'+n(v)+(x[0]==="given"?"":" · "+pct(v,given)+"%")+'</span><small class="s">'+esc(x[2])+'</small></div>';
    });
    [["pass_open","Pass opened","when its wait is up"],["bought","Bought",""]].forEach(function(x){
      var v=Number(s[x[0]])||0;
      rows.push('<div class="fp-step is-after"><span class="l">'+esc(x[1])+'</span><span class="t" aria-hidden="true"><i style="width:'+(100*v/base)+'%"></i></span>'+
        '<span class="v">'+n(v)+'</span><small class="s">'+esc(x[2])+'</small></div>');
    });
    el("fp-steps").innerHTML=rows.join("");
    el("fp-split").textContent=(Number(s.no_phone)||0)
      ?n(s.no_phone)+" opened the page without a phone number, and "+n(s.added_phone)+" of them added one there."
      :"Everyone who opened the page already had a phone number.";
    var since=s.tracked_since?new Date(s.tracked_since):null;
    el("fp-note").textContent=since&&!isNaN(since.getTime())
      ?"Every step is counted exactly since "+since.toLocaleDateString("en-US",{month:"long",day:"numeric"})+". Before that, the number, the wheel, the library, the border and the notes are filled in from the steps a player did after them."
      :"The number, the wheel, the library, the border and the notes are counted from the first player who reaches them after HUB-03. Until then they are filled in from the steps a player did after them.";
    el("fp-report").setAttribute("aria-busy","false");
  }
  /* ---- the new Fast Pass page (v2), from the first day a player used it ---- */
  function longDay(t){var d=new Date(t);return isNaN(d.getTime())?"":d.toLocaleDateString("en-US",{month:"long",day:"numeric"})}
  /* "since October 14" when the new page began inside the window, else the window's own words */
  function sinceWords(t){var at=Date.parse(t||""),start=FP.d>=99999?-Infinity:Date.now()-FP.d*864e5;return isFinite(at)&&at>start?"since "+longDay(t):rangeWords(FP.d)}
  function lowFirst(t){t=String(t||"");return /^Jan/.test(t)?t:t.charAt(0).toLowerCase()+t.slice(1)}
  function stepRow(label,v,val,sub,cls,base){
    return '<div class="fp-step'+(cls?' '+cls:'')+'"><span class="l">'+esc(label)+'</span><span class="t" aria-hidden="true"><i style="width:'+Math.min(100,100*v/base)+'%"></i></span>'+
      '<span class="v">'+val+'</span><small class="s">'+esc(sub||"")+'</small></div>';
  }
  function renderV2(s,v,x){
    var N=function(k){return Number(v[k])||0},given=N("given"),opened=N("opened"),sent=N("sent"),sw=sinceWords(v.since);
    /* QO2-13: x is datahub_quest_extra's answer, or null while it is missing (then no new rows at all) */
    var st=x&&typeof x==="object"?(x.stamps&&typeof x.stamps==="object"?x.stamps:{}):null,s3=st&&x.stamps_since,live3=!!(s3&&isNum(st.given));
    var base3=live3&&isNum(st.given)?st.given:given;
    howX(!!st);
    el("fp-report").setAttribute("data-fp-view","v2");
    el("fp-off").textContent="";
    el("fp-chips").innerHTML=
      chip("Links given",n(given),"on the new page "+sw)+
      chip("Opened the page",n(opened),pct(opened,given)+"% of the links")+
      chip("Sent to Jan",n(sent),pct(sent,opened)+"% of those who opened it")+
      chip("Bought",n(N("bought")),n(N("pass_open"))+" "+(N("pass_open")===1?"pass":"passes")+" opened so far");
    /* where they leave. The text line counts a real number only, so a step after it can hold more players than it
       does. Each drop is then counted from the nearest step before it that holds at least as many, never below zero. */
    var leaks=[];
    for(var i=1;i<STEPS2.length;i++){
      var next=N(STEPS2[i][0]),j=i-1;
      while(j>0&&N(STEPS2[j][0])<next)j--;
      var here=N(STEPS2[j][0]),gone=Math.max(0,here-next);
      if(gone>0)leaks.push({k:STEPS2[i][0],gone:gone,of:here,rate:pct(gone,here)});
    }
    leaks.sort(function(a,b){return b.gone-a.gone||b.rate-a.rate});
    var top=leaks.slice(0,3),box=el("fp-leaks");
    if(top.length){
      box.innerHTML='<ol class="fh-leak-list" aria-label="The three steps that lose the most players">'+top.map(function(L,k){
        return '<li class="fh-leak'+(k?'':' top')+'"><span class="r" aria-hidden="true">'+(k+1)+'</span><span class="nm">'+esc(LEFT_AT2[L.k]||L.k)+'</span>'+
          '<span class="ct"><b>'+n(L.gone)+'</b> left here</span><span class="rt"><span>'+L.rate+'% of the '+n(L.of)+' who got there</span>'+
          '<span class="bar" aria-hidden="true"><i style="width:'+Math.min(100,Math.max(3,L.rate))+'%"></i></span></span></li>';
      }).join("")+'</ol>';
      box.hidden=false;
    }else{box.hidden=true;box.innerHTML=""}
    el("fp-says").innerHTML=given
      ?"Of the <b>"+n(given)+"</b> players given a Fast Pass link "+esc(sw)+", <b>"+n(opened)+"</b> opened the new page and <b>"+n(sent)+"</b> sent it to Jan."+
        (!top.length?"":top[0].k==="opened"?" The biggest drop comes first. <b>"+n(top[0].gone)+"</b> never opened their link."
          :" Most stop at <b>"+esc(lowFirst(LEFT_AT2[top[0].k]))+"</b>, "+n(top[0].gone)+" of the "+n(top[0].of)+" who got there.")
      :"No player was given a Fast Pass link "+esc(sw)+".";
    var base=Math.max(given,1),rows=[];
    STEPS2.forEach(function(x){
      var c=N(x[0]);
      rows.push(stepRow(x[1],c,n(c)+(x[0]==="given"?"":" · "+pct(c,given)+"%"),x[2],"",base));
      (SIDE2[x[0]]||[]).forEach(function(y){var c2=N(y[0]);rows.push(stepRow(y[1],c2,n(c2)+" · "+pct(c2,given)+"%",y[2],"is-side",base))});
      if(st)(SIDE3[x[0]]||[]).forEach(function(y){
        var c3=st[y[0]],on=live3&&isNum(c3);
        /* the share is of the same links as the ladder; if the report counted a different number of links, the row says so */
        var sub=on&&base3!==given?"of the "+n(base3)+" links these rows count":y[2];
        rows.push(stepRow(y[1],on?c3:0,on?n(c3)+" · "+pct(c3,base3)+"%":NOT_YET,sub,"is-side is-x"+(on?"":" is-none"),Math.max(base3,1)));
      });
    });
    rows.push('<p class="fp-wait">'+(sent?'While you wait, of the '+n(sent)+' who sent it':'While you wait, once a player sends it')+'</p>');
    WAIT2.forEach(function(y){var c=N(y[0]);rows.push(stepRow(y[1],c,n(c)+" · "+pct(c,sent)+"%","","is-side is-wait",Math.max(sent,1)))});
    [["pass_open","Pass opened","when its wait is up"],["bought","Bought",""]].forEach(function(x){rows.push(stepRow(x[1],N(x[0]),n(N(x[0])),x[2],"is-after",base))});
    el("fp-steps").innerHTML=rows.join("");
    /* the window's links from before the new page (or test runs) are left out of these steps, and said so */
    var before=Math.max(0,(Number(s.given)||0)-given),day=longDay(v.since);
    el("fp-split").textContent=before
      ?n(before)+(before===1?" more link in this window was given before the first player used the new page, or to a test run, so it is":" more links in this window were given before the first player used the new page, or to test runs, so they are")+" left out of these steps."
      :"Every link in this window was given since the new page went live.";
    el("fp-note").textContent="Counted from "+day+", the first day a player used the new Fast Pass page. Jan's shop, Jan's surprise and the Priority Pass are side steps, counted as each player did them. "+
      "Until the Priority Pass line went live in October 2026, the same row counted taps on Have Jan paint. "+
      "The class border, the library and Jan's notes come after sending, so they count among the players who sent it. Test runs are left out."+
      /* QO2-13: when its five rows are there, the day they started */
      (!st?"":live3?" Jan's welcome, her greeting, Not now, the phone step and her words at the blueprint are counted from "+longDay(s3)+
        (Date.parse(s3)>Date.parse(v.since)?", so a player who passed one before then is not in its row.":"."):
        " Jan's welcome, her greeting, Not now, the phone step and her words at the blueprint are not counted yet.");
    el("fp-report").setAttribute("aria-busy","false");
  }
  function load(k){
    if(!el("fp-report"))return;
    FP.k=k||key();if(!FP.k)return;
    var mine=++FP.seq;el("fp-report").setAttribute("aria-busy","true");
    /* QO2-13: asked alongside, for the same window; missing (404), refused or failing, it is simply left out */
    var xp=rpc("datahub_quest_extra",{p_key:FP.k,p_days:FP.d,p_hours:0}).then(function(x){return x&&typeof x==="object"&&x.ok!==false?x:null},function(){return null});
    rpc("datahub_fastpass_steps",{p_key:FP.k,p_days:FP.d,p_hours:0}).then(function(s){
      if(mine!==FP.seq)return;
      if(!s||s.ok===false){paintOff(s&&s.error==="bad key"?"key":"missing");return}
      return xp.then(function(x){if(mine===FP.seq)render(s,x)});
    }).catch(function(){if(mine===FP.seq)paintOff("missing")});
  }
  var rng=el("fp-range");
  if(rng)rng.addEventListener("click",function(e){
    var b=e.target.closest("button");if(!b)return;
    Array.prototype.forEach.call(rng.querySelectorAll("button"),function(x){x.classList.toggle("on",x===b)});
    FP.d=Number(b.getAttribute("data-fd"))||30;load(FP.k);
  });

  /* ---------------- 2 · the New phone numbers tile counts the waitlist too ---------------- */
  var phoneSeq=0;
  window.ffHubPhones=function(ov,w){
    if(!ov||!key())return;
    var mine=++phoneSeq;
    rpc("datahub_waitlist_signups",{p_key:key(),p_days:w.all?99999:(w.days||30),p_hours:w.hours||0}).then(function(d){
      if(mine!==phoneSeq||!d||d.ok===false||!d.phones)return;
      var tile=document.querySelectorAll("#fh-overview .fh-kpi")[1];if(!tile)return;
      var qw=w.all?(Number(ov.phones_all)||0):(Number(ov.phones_window!=null?ov.phones_window:ov.phones_30d)||0);
      var ww=Number(w.all?d.phones.all:d.phones.window)||0,all=(Number(ov.phones_all)||0)+(Number(d.phones.all)||0);
      var v=tile.querySelector(".v"),s=tile.querySelector(".s");
      if(v)v.textContent=n(qw+ww);
      if(s)s.textContent=n(qw)+" from the Quest · "+n(ww)+" from the waitlist · "+n(all)+" all time";
      tile.title="Phone numbers from the Quest, plus waitlist sign-ups (the D&D product page, the waitlist page, the Fast Pass earn page and Klaviyo's waitlist list) whose number the Quest did not already have.";
    }).catch(function(){});
  };

  window.ffHubFunnels={load:load};
  if(window.__ffHubFunnelsPending){load(window.__ffHubFunnelsPending);window.__ffHubFunnelsPending=null}
})();
